import React, { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";

import DarkMode from "../../components/DarkMode/DarkMode";

import "./Contact.css";
import contactImg from "../../assets/img/amico.png";
import Icons from "../../components/Icons/Icons";

const dataSocemed = [
	{
		icon: "bxl:instagram",
		link: "https://www.instagram.com/mfaisalhidayatullah22/",
		color: "#da1c4a",
	},
	{
		icon: "bxl:linkedin",
		link: "https://www.linkedin.com/in/mfaisalh2429/",
		color: "#0a66c2",
	},
	{
		icon: "bxl:discord-alt",
		link: "https://discordapp.com/users/688941069668581376",
		color: "#5662f6",
	},
];

const Contact = () => {
	const [message, setMessage] = useState({
		name: null,
		email: null,
		message: null,
	});

	useEffect(() => {
		document.title = "Maish | Contact";
	}, []);

	const handleChange = (e) => {
		setMessage((prev) => ({ ...prev, [e.target.name]: e.target.value }));
	};

	const sendEmail = (e) => {
		e.preventDefault();

		if (
			(message.email === null || message.email === "") &&
			(message.name === null || message.name === "") &&
			(message.message === null || message.message === "")
		) {
			throw new Error();
		}
		const templateParams = {
			from_name: message.name,
			from_email: message.email,
			message: message.message,
			to_name: "Maish",
		};

		emailjs
			.send(process.env.REACT_APP_SERVICE_MAILJS, process.env.REACT_APP_TEMPLATE_MAILJS, templateParams, process.env.REACT_APP_PUBLIC_MAILJS)
			.then((response) => {
				Swal.fire({
					icon: "success",
					title: "Message Sent Successfully (" + response.text + ")",
				});
			})
			.catch((error) => {
				Swal.fire({
					icon: "error",
					title: "Ooops, something went wrong",
					text: error.text,
				});
			});

		e.target.reset();
		setMessage();
	};
	return (
		<section id="main" className="contact-main">
			<div className="container-fluid-contact">
				<DarkMode />
				<div className="card card-contact">
					<div className="card-body">
						<div className="row px-md-5 py-2">
							<div className="col-md-6 col-sm-12 order-2 order-md-1">
								<h3 className="tosca title-contact">Contact Me</h3>
								<form onSubmit={sendEmail}>
									<div className="mb-3 input-contact">
										<label htmlFor="name" className="form-label">
											Name
										</label>
										<input type="text" className="form-control" id="name" name="name" required onChange={handleChange} />
									</div>
									<div className="mb-3 input-contact">
										<label htmlFor="email" className="form-label">
											Email
										</label>
										<input type="email" className="form-control" id="email" name="email" required onChange={handleChange} />
									</div>
									<div className="mb-3 input-contact">
										<label htmlFor="message" className="form-label">
											Message
										</label>
										<textarea
											className="form-control"
											placeholder="Leave a message here"
											id="floatingTextarea"
											name="message"
											required
											onChange={handleChange}
										></textarea>
									</div>

									<button type="submit" className="btn btn-tosca btn-send">
										Send
									</button>
								</form>
							</div>
							<div className="col-md-6 col-sm-12 order-1 order-md-2 text-center contact-img">
								<img src={contactImg} alt="" id="contact-img" />
							</div>
						</div>
					</div>
				</div>

				<Icons data={dataSocemed} />
			</div>
		</section>
	);
};
export default Contact;
